module.exports = __webpack_public_path__ + "static/media/tj.e58f32ff.svg";